import type { QuoteTag, OptionsDocument } from 'paintscout'

export function deleteQuoteTag(args: { options: OptionsDocument; quoteTag: QuoteTag }): OptionsDocument {
  const { options, quoteTag } = args
  const key = quoteTag.name

  const values = { ...options.options.quoteTags?.values }
  if (values[key]) {
    values[key].deleted = true
  }

  return {
    ...options,
    options: {
      ...options.options,
      quoteTags: {
        ...options.options.quoteTags,
        values
      }
    }
  }
}

export function deleteQuoteTags(args: { options: OptionsDocument; quoteTags: QuoteTag[] }): OptionsDocument {
  const { options, quoteTags } = args
  return quoteTags.reduce((acc, quoteTag) => deleteQuoteTag({ options: acc, quoteTag }), options)
}
